const lbaSubHeading = angular.module('app.lbaSubHeading', []);

lbaSubHeading.controller('lbaSubHeadingCtrl', require('./lbaSubHeadingCtrl'));
lbaSubHeading.directive('lbaSubHeading', require('./lbaSubHeadingDir'));

export default lbaSubHeading;



// WEBPACK FOOTER //
// ./src/components/lbaSubHeading/index.js